import { Route } from '@angular/router';

export const DEBUG_ROUTES: Route[] = [
    {
        path: '',
        redirectTo: 'configuration',
        pathMatch: 'full'
    },
    {
        path: 'configuration',
        loadComponent: () => import('./components/configuration/configuration.component').then((comp) => comp.ConfigurationComponent)
    },
    {
        path: 'toggles',
        loadComponent: () => import('./components/toggles/toggles.component').then((comp) => comp.TogglesComponent)
    },
    {
        path: 'env-variables',
        loadComponent: () => import('./components/env-variables/env-variables.component').then((comp) => comp.EnvVariablesComponent)
    },
    {
        path: 'configs',
        loadComponent: () => import('./components/configs/configs.component').then((comp) => comp.ConfigsComponent)
    },
    {
        path: 'viewer',
        loadComponent: () => import('./components/viewer/viewer.component').then((comp) => comp.ViewerComponent)
    },
    {
        path: 'cache-details',
        loadComponent: () => import('./components/cache-details/cache-details.component').then((comp) => comp.CacheDetailsComponent)
    },
    {
        path: 'allowed-cookies',
        loadComponent: () => import('./components/allowed-cookies/allowed-cookies.component').then(com => com.AllowedCookiesComponent)
    }
];
